export type AnimationDirection = 'right' | 'left' | 'none';

export const ANIMATION_DIRECTION: Record<string, AnimationDirection> = {
  RIGHT: 'right',
  LEFT: 'left',
  NONE: 'none',
};

export type CarouselContentAnimateStage =
  | 'fade-in'
  | 'fade-out'
  | 'pre-fade-in'
  | null;

export const ANIMATION_STAGE: Record<string, CarouselContentAnimateStage> = {
  FADE_IN: 'fade-in',
  FADE_OUT: 'fade-out',
  PRE_FADE_IN: 'pre-fade-in',
} as const;
